var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"BasePageLoadingProgress page-loading-progress",attrs:{"height":"3","color":"#2E7A56","top":"","value":_vm.progress}})
}
var staticRenderFns = []

export { render, staticRenderFns }